const getTrendPercentage = (rateOfChange) => (
  `${(Math.abs(rateOfChange) * 100).toFixed(2)}%`
);

export default getTrendPercentage;
